var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "kefuAdjustRules" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("span", { staticClass: "Dia_title" }, [
                _vm._v("商品中心-客户级调价规则"),
              ]),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%", "margin-top": "20px" },
              attrs: {
                data: _vm.goodsData,
                border: "",
                "header-cell-style": {
                  backgroundColor: "#f5f7fa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "rule_id",
                  label: "规则ID",
                  width: "100",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "rule_name", label: "规则名称" },
              }),
              _c("el-table-column", {
                attrs: { prop: "type", label: "类型", width: "100px" },
              }),
              _c("el-table-column", { attrs: { prop: "rule", label: "规则" } }),
              _c("el-table-column", {
                attrs: { prop: "resource", label: "资源范围" },
              }),
              _c("el-table-column", {
                attrs: { prop: "is_set_timing", label: "是否设置生效时间" },
              }),
              _c("el-table-column", {
                attrs: { prop: "real_money", label: "添加时间/修改时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.created_time) +
                              " " +
                              _vm._s(scope.row.creator_name)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.updated_time) +
                              " " +
                              _vm._s(scope.row.updater_name)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card",
          staticStyle: { "margin-top": "20px" },
          attrs: { shadow: "never" },
        },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "span",
                {
                  staticClass: "Dia_title",
                  on: { click: function ($event) {} },
                },
                [_vm._v("菜单管理-客户级调价规则")]
              ),
            ]
          ),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                border: "",
                "header-cell-style": {
                  background: "#F1F1F1",
                  color: "#333333",
                },
                data: _vm.menuData,
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "category_id", label: "菜单ID-名称-类型" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.category_id))]),
                        _c("div", [
                          _vm._v(_vm._s(scope.row.category_name) + " "),
                          scope.row.category_alias_name
                            ? _c("span", [
                                _vm._v(
                                  "(" +
                                    _vm._s(scope.row.category_alias_name) +
                                    ")"
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _c("div", [_vm._v(_vm._s(scope.row.category_type))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "category_name", label: "商品折扣" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "商品折扣：" +
                              _vm._s(scope.row.is_open_discount_message)
                          ),
                        ]),
                        scope.row.is_open_discount === "1"
                          ? [
                              _c("div", [
                                _vm._v(
                                  "调价基数：" +
                                    _vm._s(scope.row.money_type_name)
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  "折 扣：" +
                                    _vm._s(scope.row.by_ratio_adjust) +
                                    "%"
                                ),
                              ]),
                              _c("div", [
                                _vm._v(
                                  " 划线价：" +
                                    _vm._s(scope.row.is_show_line_price_message)
                                ),
                              ]),
                            ]
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "number_comments", label: "评论数限制" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "评论数限制：" +
                              _vm._s(scope.row.is_number_comments_message)
                          ),
                        ]),
                        scope.row.is_number_comments === "1"
                          ? _c("div", [
                              _vm._v(
                                "京东评论数：" +
                                  _vm._s(scope.row.number_comments)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "entity_profit_rate", label: "利润率限制" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "利润率限制：" +
                              _vm._s(scope.row.is_entity_profit_rate_message)
                          ),
                        ]),
                        scope.row.is_entity_profit_rate === "1"
                          ? _c("div", [
                              _vm._v(
                                "利润率：" +
                                  _vm._s(scope.row.entity_profit_rate) +
                                  "%"
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "entity_profit_rate",
                  label: "商品关键词黑名单",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            "商品关键词黑名单：" +
                              _vm._s(scope.row.is_keyword_blacklist_message)
                          ),
                        ]),
                        scope.row.is_keyword_blacklist === "1"
                          ? _c("div", [
                              _vm._v(
                                "关键词黑名单：" +
                                  _vm._s(scope.row.keyword_blacklist)
                              ),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "created_time", label: "添加-更新时间" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.created_time) +
                              " " +
                              _vm._s(scope.row.creator_name)
                          ),
                        ]),
                        _c("div", [
                          _vm._v(
                            _vm._s(scope.row.updated_time) +
                              " " +
                              _vm._s(scope.row.updater_name)
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            size: "80%",
            "custom-class": "myDrawer",
            "destroy-on-close": "",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _c("span", {
            attrs: { slot: "title" },
            domProps: { innerHTML: _vm._s(_vm.drawerTitle) },
            slot: "title",
          }),
          _c("menu-adjust-drawer", { attrs: { trendParams: _vm.trendParams } }),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawerGood,
            size: "80%",
            "custom-class": "myDrawer",
            "destroy-on-close": "",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawerGood = $event
            },
          },
        },
        [
          _c("span", {
            attrs: { slot: "title" },
            domProps: { innerHTML: _vm._s(_vm.drawerTitleGood) },
            slot: "title",
          }),
          _c(
            "div",
            { staticStyle: { margin: "0 20px" } },
            [
              _vm.goodsType === "movie"
                ? _c("cinema-adjust-rule", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "zyd"
                ? _c("zyd-set-discount", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "entrance_ticket"
                ? _c("ticket-adjust-rule", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "cake_to_door"
                ? _c("cake-home-adjust-rule-list", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "cake_store"
                ? _c("cake-store-adjust-rule-list", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "online_foods"
                ? _c("online-discount", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "flower"
                ? _c("flower-adjust-rule-list", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
              _vm.goodsType === "yanchu"
                ? _c("new-perform-adjust-rule-list", {
                    attrs: { trendParamsGood: _vm.trendParamsGood },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }